import React, { useEffect, useState } from "react";
import dataFteService from "../../services/dataFte.service";
import ChangeDean from "./changeDean";

const Dean = () => {
  const [dean, setDean] = useState("");
  useEffect(() => {
    (async () => {
      //ไปเช็คที่ตาราง doc3 ว่ามี sche / course นี้ยัง
      await dataFteService.getData().then((res) => {
        setDean(res.data[0].dean);
      });
    })();
  }, []);

  return (
    <div className="card bg-light">
      <div className="card-body">
        <h3 className="card-title">คณบดี</h3>
        <h4 className="card-text">
          <strong>{dean}</strong>
        </h4>
        <p>คณบดีคณะครุศาสตร์อุตสาหกรรม</p>
        <ChangeDean name={dean} />
      </div>
    </div>
  );
};

export default Dean;
